import React, { Component } from "react";
import Cookies from 'universal-cookie';
const axios = require("axios");
const cookies = new Cookies();
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginError: null,
    }
  }

  componentDidMount() {
    document.getElementsByTagName("nav")[0].hidden = true;
  }
  handleSubmit(that) {
    var serviceUrl =
        "https://api.transportationprojects.org/api/auth/signin";
    axios
      .post(serviceUrl, {
        usernameOrEmail: document.getElementById("uname").value,
        password: document.getElementById("pwd").value
      })
      .then(function (response) {
        let data = response.data;
        console.log(data);
        localStorage.setItem("name", data.user.name);
        localStorage.setItem("role", JSON.stringify(data.user.roles));
        localStorage.setItem("id", data.user.id);
        localStorage.setItem("email", data.user.email);
        cookies.set('token', data.jwtAuthenticationResponse.accessToken, { path: '/', maxAge:7200 });
        localStorage.setItem("createdAt", data.user.createdAt);
        localStorage.setItem("updatedAt", data.user.updatedAt);
        localStorage.setItem("username", data.user.username);
        localStorage.setItem("states", data.user.states);
        window.location.reload();
      })
      .catch(function (error) {
        //alert("Invalid username or password! Please try again.");
        if (error.toString().includes("400")) {
          that.setState({ loginError: "Insufficient permissions. Please request for more access."});
        } else {
          that.setState({ loginError: "Invalid username or password! Please try again."});
        }
      });
  }

  render() {
    return (
      <div className="col-md-6 container-fluid my-5">
        <div className="card card-outline-secondary">
          <div
            className="card-header navbar navbar-expand-lg navbar-dark header"
            style={{ backgroundColor: "#3976C3" }}
          >
            <img
              className="img-fluid mx-2"
              alt="logo"
              width="80px"
              height="80px"
              src="http://www.transportationprojects.org/img/website-logo.png"
            />
            <strong
              className="text-white mx-5"
              style={{ fontSize: "15pt" }}
              id="title"
              href="/"
            >
              US Major Transportation Projects
              <p id="sub">
                <h3 style={{ color: "yellow" }}>Data Management System</h3>
              </p>
            </strong>
          </div>
          <div className="card-body" />
          <form
            autoComplete="off"
            className="form mx-4"
            id="formLogin"
            name="formLogin"
            onSubmit={(e) => {
              e.preventDefault();
              this.handleSubmit(this);
            }}
          >
            <div className="form-group">
              <label htmlFor="uname1">Username Or Email</label>
              <input
                className="form-control"
                id="uname"
                name="uname"
                required=""
                type="text"
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                autoComplete="new-password"
                className="form-control"
                id="pwd"
                required=""
                type="password"
              />
            </div>

            <div>
            {this.state.loginError && (
                <small className="text-danger">{this.state.loginError}</small>
            )}
            </div>

            <a
              href="http://www.transportationprojects.org/resetPassword.html"
              className="float-left my-3 mx-1"
            >
              Forgot password?
            </a>

            <button
              id="loginButton"
              className="btn btn-warning btn-md float-right my-3"
              type="submit"
            >
              Login
            </button>
          </form>
        </div>
      </div>
    );
  }
}
export default Login;
